import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';
import {
  SystemTypeEnum
} from 'src/app/domain/registration/enums/system-type.enum';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { AuthService } from 'src/app/views/auth/shared/auth.service';
import { PlanService } from '../../plans/crud-service';
import { SystemService } from '../../systems/crud-service';

@Component({
  selector: 'app-customer-plan-select-items',
  templateUrl: './customer-plan-items-select.component.html',
  styleUrls: ['./customer-plan-items.component.sass'],
})
export class CustomerPlanItemsSelectComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  @ViewChild(MatTable) table: MatTable<any>;

  indexSelect = -1;

  @Input()
  typeCes: TypeCesEnum;

  @Input()
  itemSelected: { index: number; element: any | undefined };

  @Input()
  partnerSelectedFire: EventEmitter<any>;

  partner: any;

  @Output()
  changeSelected: EventEmitter<any> = new EventEmitter();

  @Input()
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);

  @Output()
  dataSourceChange: EventEmitter<any> = new EventEmitter();

  displayedColumns: String[] = [
    'code',
    'type',
    'system',
    'terminalQuantity',
    'monthlyValue',
    'dueDate',
    'adhesionFee',
    'daysCountQuantity',
    'daysCountValue',
    'deploymentValue',
    'createdAt',
    'active',
  ];

  private typeSub: Subscription | undefined;
  private terminalQuantitySub: Subscription | undefined;
  private systemSub: Subscription | undefined;

  monthlyValueLoaded = 0;
  rowEdit: any;

  get typeCesEnum() {
    return TypeCesEnum;
  }

  constructor(
    private authService: AuthService,
    public dialogRefSelect: MatDialogRef<CustomerPlanItemsSelectComponent>,
    @Inject(MAT_DIALOG_DATA)
    data: { type: TypeCesEnum; params: { plans: any[]} },
  ) {
    this.typeCes = data.type;
    this.dataSource.data = data.params.plans;
  }

  ngOnDestroy(): void {
    this.typeSub?.unsubscribe();
    this.terminalQuantitySub?.unsubscribe();
    this.systemSub?.unsubscribe();
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
  }

  public getCode(value: any) {
    return `${value}`.padStart(2, '0');
  }

  get systemTypeEnum() {
    return SystemTypeEnum;
  }

  public select(row: any, selected: any) {
    this.changeSelected.emit(selected);
    this.indexSelect = selected;
    this.itemSelected = selected;
    this.dialogRefSelect.close(row);
  }

  public getNgClass(element: any, index: number) {
    if (index === this.indexSelect) return 'selected';

    let type =
      element.type === this.systemTypeEnum.SYSTEM ? 'system' : 'application';
    let disabled = element.active ? '' : 'disabled';

    return `${type} ${disabled}`;
  }

  public isEditable(i: any, element: any): any {
    return (
      !this.authService.isPartner() && this.typeCes !== this.typeCesEnum.SHOW
    );
  }

  public isRemovable(i: any, element: any): any {
    if (!this.authService.isPartner()) {
      return true;
    }

    return this.typeCes == TypeCesEnum.EDIT && !element.id;
  }
}
